import EventBanner from './EventBanner';

export default EventBanner;
